import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import CashInForm from '../cash_in/CashInForm';
import CashOutForm from '../cash_out/CashOutForm';
import OperationsForm from '../operations/OperationsForm';

const QuickActions = () => {
  const theme = useTheme();
  const [openDialog, setOpenDialog] = useState(null);

  const handleOpenDialog = (type) => setOpenDialog(type);
  const handleCloseDialog = () => setOpenDialog(null);

  const actions = [
    {
      id: 'income',
      label: 'Nova Receita',
      color: theme.palette.success.main,
      lightColor: theme.palette.success.light,
      dialogTitle: 'Nova Receita',
      FormComponent: CashInForm,
    },
    {
      id: 'expense',
      label: 'Novo Custo',
      color: theme.palette.error.main,
      lightColor: theme.palette.error.light,
      dialogTitle: 'Novo Custo',
      FormComponent: CashOutForm,
    },
    {
      id: 'investment',
      label: 'Nova Operacao',
      color: theme.palette.info.main,
      lightColor: theme.palette.info.light,
      dialogTitle: 'Nova Operacao',
      FormComponent: OperationsForm,
    },
  ];

  return (
    <>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="caption"
          sx={{
            textTransform: 'uppercase',
            letterSpacing: 1,
            color: theme.palette.text.secondary,
            mb: 1.5,
            display: 'block',
          }}
        >
          Acoes Rapidas
        </Typography>
        <Box
          sx={{
            display: 'flex',
            gap: 1.5,
            flexWrap: 'wrap',
          }}
        >
          {actions.map((action) => (
            <Button
              key={action.id}
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={() => handleOpenDialog(action.id)}
              sx={{
                borderRadius: 6,
                px: 2.5,
                py: 1,
                textTransform: 'none',
                fontWeight: 500,
                color: action.color,
                borderColor: alpha(action.color, 0.5),
                backgroundColor: alpha(action.color, 0.04),
                transition: 'all 0.2s',
                '&:hover': {
                  borderColor: action.color,
                  backgroundColor: alpha(action.color, 0.1),
                },
              }}
            >
              {action.label}
            </Button>
          ))}
        </Box>
      </Box>

      {actions.map((action) => (
        <Dialog
          key={action.id}
          open={openDialog === action.id}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            {action.dialogTitle}
            <IconButton
              aria-label="close"
              onClick={handleCloseDialog}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <action.FormComponent onCreate={handleCloseDialog} />
          </DialogContent>
        </Dialog>
      ))}
    </>
  );
};

export default QuickActions;
